<template>
  <div class="radiobutton-quantity-wrap">
    <RadioButton :label="inputValue.product.name"
                 :inputValue="inputValue.id"
                 :name="name"
                 @input="handleRadioChange" />

    <VItemCounter v-if="isChecked"
                  :max="limit"
                  size="small"
                  :value="quantity"
                  @update:value="updateQuantity" />
  </div>
</template>

<script>
import RadioButton from '@/components/RadioButton.vue';
import VItemCounter from "@/components/ui/VItemCounter.vue";

export default {
  name: "RadioButtonWithQuantity",
  components: {
    RadioButton,
    VItemCounter,
  },
  props: {
    inputValue: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
      default: {},
    },
    limit: {
      type: Number,
      default: 5,
    },
    name: { type: [String, Number] }
  },
  data() {
    return {
      quantity: 1,
    };
  },
  computed: {
    isChecked() {
      return this.value.id === this.inputValue.id;
    },
  },
  methods: {
    handleRadioChange() {
      this.$emit('input', { ...this.inputValue, quantity: this.quantity });
    },
    updateQuantity(val) {
      this.quantity = val;

      this.$emit('input', this.value.id === this.inputValue.id ? { ...this.value, quantity: this.quantity } : this.value);
    },
  },
};
</script>


<style lang="scss" scoped>
.radiobutton-quantity-wrap {
  display: grid;
  gap: 12px;
}
</style>